<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{ title }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <ion-searchbar @keypress.enter="doSearch($event.target.value)" animated mode="ios" />
            <ion-item v-if="! (results && results.length > 0)">
                <ion-label>No results found</ion-label>
            </ion-item>
            <ion-item button v-for="item in results" :key="item.id" :detail="true" @click="select(item)">
                <ion-avatar>
                    <single-item-image :item="item"/>
                </ion-avatar>
                <ion-label class="ion-margin-start">
                    <h2>{{ item.item_number }}</h2>
                    <p>
                        {{ item.name }}
                    </p>
                </ion-label>
            </ion-item>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonSearchbar,
    IonPage,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonContent,
    IonButtons,
    IonButton,
    IonIcon,
    IonAvatar,
    IonLabel,
    IonItem
} from '@ionic/vue';
import {modalController} from '@ionic/vue';
import {closeOutline} from 'ionicons/icons';
import SingleItemImage from "@/components/SingleItemImage";
import EventBus from "@/EventBus";
import router from '@/router';
export default {
    props: {include: {default: 'skus,locations,locations.pivot,image_urls'}, modelValue: Number, title: {default: 'Item Search'}},
    emits: ['update:modelValue'],
    inject: ['$http'],
    name: 'ItemSearchModal',
    components: {
        SingleItemImage,
        IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons,
        IonButton, IonIcon, IonLabel, IonAvatar, IonItem, IonSearchbar
    },
    data() {
        return {
            results: [],
            search: ''
        }
    },
    methods: {
        doSearch(search) {
            EventBus().emitter.emit('loading', true);
            this.$http
                .get('/api/items', {params: { fts: search, include: this.include }})
                .then(response => {
                    this.results = response.data.items;
                    EventBus().emitter.emit('loading', false);
                }).catch(() => {
                    EventBus().emitter.emit('loading', false);
                });
        },
        select(item) {
            modalController.dismiss(item);
        },
        close() {
            modalController.dismiss();
        }
    },
    setup() {
        return {
            closeOutline
        }
    }
}
</script>
